import NeedLoginError from "lib@/errors/need_login_error";
import ShowMsgError from "lib@/errors/show_msg_error";
import {log} from "lib@/util";
import App from "lib@/app";
import Cfg from 'src@/libs/cfg';

/**
 * 后端接口的基础类
 */
 class BaseApi
 {
    constructor() {

    }

    callApiAutoStop(requestPromise, beforeResponseCallback = null){
        return new Promise((resolve, reject) => {
            requestPromise.then((res) => {
                if(beforeResponseCallback){
                    beforeResponseCallback(true, res);
                }
                resolve(res);
            })
            .catch((error) => {
                let next = true;

                if(beforeResponseCallback){
                    next = beforeResponseCallback(false, error);
                }

                if(next !== false){
                    this.exceptionHandle(error);
                }
            })
        });
    }

    exceptionHandle(error) {
        log(error);
        if(error instanceof NeedLoginError){
            App.router.go('/login');
        }
        else if(error instanceof ShowMsgError){
            layui.layer.msg(
                error.message,
                {
                    icon: 5
                    ,shade:0.1
                }
            );
        }
    }

    //接口路径处理，依据配置更换对应的请求路径
    apiPathHandle(path = "") {
        if (('visit_open_api' in Cfg) && Cfg['visit_open_api']) {
            //访视报告开放路径
            return "/partner/visit-open-api" + path;
        }
        return "/partner" + path;
    }

 }

 export default BaseApi;